import { MdFaceUnlock } from "react-icons/md"
import { useNavigate } from "react-router-dom"

export default function ActiveCases({cases}) {
const navigate = useNavigate()
  return (
    <div className="bg-white rounded-2xl p-4 shadow-custom  ">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-medium">Active Cases</h2>
        <span className="text-xl">{cases.length}</span>
      </div>
      <div className="space-y-4 max-h-[400px] overflow-y-auto">
        {cases.map((app, index) => (
          <div key={index} className="bg-[#005787] text-white p-3 rounded-lg flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0 flex-1">
              <div className="w-10 h-10 bg-white rounded-full overflow-hidden flex items-center justify-center">
                <MdFaceUnlock className="w-7 h-7 text-gray-600" />
              </div>
              <div className="min-w-0 flex-1 max-w-[170px] sm:max-w-[220px]">
                <p title={`${app.firstName || ""} ${app.lastName || ""}`.trim()} className="font-medium whitespace-normal break-words leading-snug">{app.firstName+ " " + app.lastName}</p>
                <p title={app.countryOfInterest || ""} className="text-sm opacity-75 whitespace-normal break-words leading-snug">{app.countryOfInterest}</p>
              </div>
            </div>
            <button onClick={()=>navigate("/admin/leads/"+app._id)} className="text-xs bg-black/20 px-3 py-1 rounded-full shrink-0">View</button>
          </div>
        ))}
        {cases.length === 0 && <p className="text-red-500 text-center py-4">No active cases</p>}
      </div>
    </div>
  )
}